/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Editors_Delete_ActionInputs */

const en_us2_profile_editors_delete_action = /** @type {(inputs: Profile_Editors_Delete_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete forever`)
};

const pt_br2_profile_editors_delete_action = /** @type {(inputs: Profile_Editors_Delete_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Excluir para sempre`)
};

const es_419_profile_editors_delete_action = /** @type {(inputs: Profile_Editors_Delete_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminar para siempre`)
};

const pt_pt2_profile_editors_delete_action = /** @type {(inputs: Profile_Editors_Delete_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminar para sempre`)
};

const fr_fr2_profile_editors_delete_action = /** @type {(inputs: Profile_Editors_Delete_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supprimer définitivement`)
};

const de_de2_profile_editors_delete_action = /** @type {(inputs: Profile_Editors_Delete_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Endgültig löschen`)
};

const it_it2_profile_editors_delete_action = /** @type {(inputs: Profile_Editors_Delete_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elimina per sempre`)
};

/**
* | output |
* | --- |
* | "Delete forever" |
*
* @param {Profile_Editors_Delete_ActionInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_delete_action = /** @type {((inputs?: Profile_Editors_Delete_ActionInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Delete_ActionInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_delete_action(inputs)
	if (locale === "es-419") return es_419_profile_editors_delete_action(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_delete_action(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_delete_action(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_delete_action(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_delete_action(inputs)
	return en_us2_profile_editors_delete_action(inputs)
});
export { profile_editors_delete_action as "profile-editors.delete_action" }